<template>
    <div class="main-wrap">
        <template v-if="userIsAuth == 'p' || userIsAuth == 'n' || userIsAuth == 'y'">
            <div class="item">
                <div class="label">业务负责人</div>
                <div class="content">
                    <div class="text" v-if="!editBrand.companyKeyPerson">{{userInfo.companyKeyPerson}}</div>
                    <div class="edit-box" v-else>
                        <el-form :model="brandForm" ref="companyKeyPerson">
                            <el-form-item
                                prop="companyKeyPerson"
                                :rules="[
                                    { required: true, message: '请输入业务负责人姓名'},
                                ]"
                            >
                                <el-input v-model="brandForm.companyKeyPerson" size="small"
                                    placeholder="请输入业务负责人姓名"
                                ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" size="small" @click="submitBrandForm('companyKeyPerson')">保存</el-button>
                                <el-button size="small" @click="editBrand.companyKeyPerson = false">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="btn-wrap">
                    <!-- <i class="icon-edit" @click="editBrandHandle('companyKeyPerson')"></i> -->
                </div>
            </div>
            <div class="item">
                <div class="label">业务负责人电话</div>
                <div class="content">
                    <div class="text" v-if="!editBrand.companyKeyPersonPhone">{{userInfo.companyKeyPersonPhone}}</div>
                    <div class="edit-box" v-else>
                        <el-form :model="brandForm" ref="companyKeyPersonPhone">
                            <el-form-item
                                prop="companyKeyPersonPhone"
                                :rules="[
                                    { required: true, message: '请输入业务负责人电话'},
                                ]"
                            >
                                <el-input v-model="brandForm.companyKeyPersonPhone" size="small"
                                    placeholder="请输入业务负责人电话"
                                ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" size="small" @click="submitBrandForm('companyKeyPersonPhone')">保存</el-button>
                                <el-button size="small" @click="editBrand.companyKeyPersonPhone = false">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="btn-wrap">
                    <!-- <i class="icon-edit" @click="editBrandHandle('companyKeyPersonPhone')"></i> -->
                </div>
            </div>
            <div class="item">
                <div class="label">公司电话</div>
                <div class="content">
                    <div class="text" v-if="!editBrand.companyPhone">{{userInfo.companyPhone}}</div>
                    <div class="edit-box" v-else>
                        <el-form :model="brandForm" ref="companyPhone">
                            <el-form-item
                                prop="companyPhone"
                                :rules="[
                                    { required: true, message: '请输入公司电话'},
                                ]"
                            >
                                <el-input v-model="brandForm.companyPhone" size="small"
                                    placeholder="请输入公司电话"
                                ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" size="small" @click="submitBrandForm('companyPhone')">保存</el-button>
                                <el-button size="small" @click="editBrand.companyPhone = false">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="btn-wrap">
                    <!-- <i class="icon-edit" @click="editBrandHandle('companyPhone')"></i> -->
                </div>
            </div>
            <div class="item">
                <div class="label">公司地址</div>
                <div class="content">
                    <div class="text" v-if="!editBrand.address">{{userInfo.addressStr}}</div>
                    <div class="edit-box" v-else>
                        <el-form :model="brandForm" ref="address">
                            <el-form-item prop="addressArea" size="small" required
                                :rules="[
                                    { validator: validAddressArea},
                                ]"
                            >
                                <area-picker type="edit" :data.sync="brandForm.addressArea" />
                            </el-form-item>
                            <el-form-item prop="addressString" size="small"
                                :rules="[
                                    { required: true, message: '请输入详细地址'},
                                ]"
                            >
                                <el-input type="textarea" v-model.trim="brandForm.addressString"
                                    placeholder="请输入详细地址"
                                ></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" size="small" @click="submitBrandForm('address')">保存</el-button>
                                <el-button size="small" @click="editBrand.address = false">取消</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="btn-wrap">
                    <!-- <i class="icon-edit" @click="editBrandHandle('address')"></i> -->
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import api from '@/api'
import request from '@/utils/request'
import { mapGetters } from 'vuex'
import areaPicker from '@/components/areaPicker.vue'

export default {
    components: {
        areaPicker
    },
    data() {
        return {
            editBrand: {
                companyKeyPerson: false,
                companyKeyPersonPhone: false,
                companyPhone: false,
                address: false,
            },
            brandForm: {
                companyKeyPerson: '',
                companyKeyPersonPhone: '',
                companyPhone: '',
                addressArea: {
                    regionProvince: {
                        region_name:  '',
                        region_id: ''
                    },
                    regionCity: {
                        region_name:  '',
                        region_id: ''
                    },
                    regionDistrict: {
                        region_name:  '',
                        region_id: ''
                    }
                },
                addressString: '',
            },
        }
    },
    computed: {
        ...mapGetters(['userId', 'userIsAuth', 'userInfo'])
    },
    created() {
        this.getBrandData()
    },
    methods: {
        // 打开编辑
        editBrandHandle(keyName) {
            this.editBrand[keyName] = true
            if (keyName === 'companyKeyPerson') {
                this.brandForm.companyKeyPerson = this.userInfo.companyKeyPerson
            }
            if (keyName === 'companyKeyPersonPhone') {
                this.brandForm.companyKeyPersonPhone = this.userInfo.companyKeyPersonPhone
            }
            if (keyName === 'companyPhone') {
                this.brandForm.companyPhone = this.userInfo.companyPhone
            }
            if (keyName === 'address') {
                this.brandForm.addressArea = {
                    regionProvince: {
                        region_name: this.userInfo.companyProvinceStr || '',
                        region_id: this.userInfo.companyProvince || '',
                    },
                    regionCity: {
                        region_name: this.userInfo.companyCityStr || '',
                        region_id: this.userInfo.companyCity || '',
                    },
                    regionDistrict: {
                        region_name: this.userInfo.companyDistrictStr || '',
                        region_id: this.userInfo.companyDistrict || '',
                    }
                }
                this.brandForm.addressString = this.userInfo.factoryAddressStr || ''
            }
        },
        // 提交编辑
        submitBrandForm(keyName) {
            this.$refs[keyName].validate((valid) => {
                if (valid) {
                    // console.log('pass')
                    
                    let params = {
                        "userId": this.userId,
                        "companyProvince": this.userInfo.companyProvince,
                        "companyCity": this.userInfo.companyCity,
                        "companyDistrict": this.userInfo.companyDistrict,
                        "companyPhone": this.userInfo.companyPhone,
                        "companyKeyPerson": this.userInfo.companyKeyPerson,
                        "companyKeyPersonPhone": this.userInfo.companyKeyPersonPhone
                    }

                    if (keyName === 'companyKeyPerson') {
                        params.companyKeyPerson = this.brandForm.companyKeyPerson
                    }
                    if (keyName === 'companyKeyPersonPhone') {
                        params.companyKeyPersonPhone = this.brandForm.companyKeyPersonPhone
                    }
                    if (keyName === 'companyPhone') {
                        params.companyPhone = this.brandForm.companyPhone
                    }
                    if (keyName === 'address') {
                        let { addressArea } = this.brandForm
                        params.companyProvince = addressArea.regionProvince.region_id
                        params.companyCity = addressArea.regionCity.region_id
                        params.companyDistrict = addressArea.regionDistrict.region_id
                        params.factoryAddress = this.brandForm.addressString
                    }
                
                    request({
                        url:api.editUserAuth,
                        data: params
                    }).then(res => {
                        // console.log(res)
                        if (res.errorCode == 200) {
                            this.$store.dispatch('getUserInfo')
                            this.editBrand[keyName] = false
                        } else {
                            this.$message.error(res.errorMsg || '编辑失败')
                        }
                    })
                }
            })
        },
        // 自定义校验函数
        validAddressArea(rule, value, callback) {
            // console.log(value)
            if (!this.brandForm.addressArea.regionCity.region_id) {
                callback(new Error('请选择省市区'))
            } else {
                callback()
            }
        },
    }
}
</script>